import React from 'react';
import styles from './SectionHeader.module.scss';

interface SectionHeaderProps {
    title: string;
    subtitle: string;
}

const SectionHeader = ({ title, subtitle }: SectionHeaderProps) => {
    return (
        <div className={styles.header}>
            <h2 className={styles.title}>{title}</h2>
            <p className={styles.subtitle}>{subtitle}</p>
        </div>
    );
};

export default SectionHeader;
